<template>
  <div class="studentEdit">
    <v-breadcrumbs>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
        >Home</v-breadcrumbs-item
      >
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :exact="true" :to="{ name: 'student', params: {} }">
        Student
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider v-if="student">/</v-breadcrumbs-divider>
      <v-breadcrumbs-item
        v-if="student"
        :exact="true"
        :to="{ name: 'studentView', params: { id: student.id } }"
      >
        {{ student.firstName }} {{ student.lastName }}
      </v-breadcrumbs-item>
      <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
      <v-breadcrumbs-item :to="{ name: 'studentEdit', params: { id: id } }">
        Edit Student
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-card>
      <v-card-title>Edit Student</v-card-title>
      <v-card-text>
        <student-form v-model="student" :id="id"></student-form>
      </v-card-text>
    </v-card>
  </div>
</template>

    <script>
import StudentForm from "./StudentForm.vue";

export default {
  name: "student",
  data() {
    return {
      id: null,
      student: null
    };
  },
  components: {
    StudentForm,
  },
  created() {
    this.id = this.$route.params.id;
    this.$emit("showParent", false);
  },
};
</script>
    